export default __webpack_public_path__ + "static/media/normal.a0660151.png";